import React from 'react';
import { useSelector } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import { ResolverTag, Site } from '@swf/core/enums';
import useResolver from '@swf/core/hooks/useResolver';
import { select } from '@swf/core/store';

import {
  TXTCLI_Responsible_Gaming,
  TXTMOB_In_partnership_with,
  TXTWCL_If_you_or_someone_you_know_has_ELL,
  TXTWCL_If_you_or_someone_you_know_has_ELL_2
} from './RegulatoryHeaderUS.messages.json';
import styles from './RegulatoryHeaderUS.scss';
import odawaOnlineIcon from './assets/odawa-online.png';
import responsibleGamingIcon from './assets/responsible-gaming.png';

const RegulatoryHeaderUS: React.FC = () => {
  const site = useSelector(select.site.getId);
  const helpResponsibleGaming = useResolver(ResolverTag.HelpResponsibleGaming);

  return (
    <>
      {site === Site.USMI && (
        <div className={styles.odawa}>
          <span className={styles.regulatoryText}>
            <Translation {...TXTMOB_In_partnership_with} />
          </span>
          <img src={odawaOnlineIcon} alt="" />
        </div>
      )}
      <div className={styles.responsibleGaming}>
        <span className={styles.regulatoryText}>
          <Translation
            {...(site === Site.USMI
              ? TXTWCL_If_you_or_someone_you_know_has_ELL_2
              : TXTWCL_If_you_or_someone_you_know_has_ELL)}
            values={{ 0: site === Site.USNJ ? '1-800-Gambler' : '1-800-522-4700' }}
          />
        </span>
        <a href={helpResponsibleGaming} target="_blank" rel="noopener noreferrer">
          <img
            width={24}
            height={24}
            className={styles.regulatoryIcon}
            src={responsibleGamingIcon}
            alt=""
          />
        </a>
        <a
          href={helpResponsibleGaming}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.regulatoryIconText}
        >
          <Translation {...TXTCLI_Responsible_Gaming} />
        </a>
      </div>
    </>
  );
};

export default RegulatoryHeaderUS;
